import fetch from "./fetch";
import reset from "./reset";

export const actions = {
    fetch,
    reset,
};
